import { getSephiraIconnectApi } from '../../../api/apisauceConfig'
import { serializeSephiraPayload } from './mapper/sephira.mapper'
import { SephiraVitalCardResponse } from './mapper/sephira.model'

export const getSephiraVitalCardInfos = (date: Date, pinCode?: string) =>
  getSephiraIconnectApi().post<SephiraVitalCardResponse>(
    '/vitale_reader/SIS_LireDroitsVitale',
    serializeSephiraPayload(date, pinCode),
  )
